import moment from 'moment'
import * as Yup from 'yup'
/* eslint-disable import/prefer-default-export */
export const steepOneSchema = Yup.object().shape({
  receptionDate: Yup.string().required('La fecha de recepción es requerida'),
  isPartnerZone: Yup.boolean(),
  zone: Yup.string().required('La zona es requerida'),
  prefecture: Yup.string().required('La prefectura es requerida'),
  unit: Yup.string().required('La unidad es requerida'),
  relationship: Yup.string().required('El Parentesco es Requerido'),
  alternativePhone: Yup.string()
    .min(8, 'El telefono no es valido')
    .max(9, 'El telefono no es valido'),
  partnerRut: Yup.string()
    .min(11, 'El Rut no es valido')
    .max(12, 'El Rut no es valido'),
  partnerPhone: Yup.string()
    .min(8, 'El telefono no es valido')
    .max(9, 'El telefono no es valido')
    .required('El telefono es requerido'),
  partnerGrade: Yup.string(),
  partnerCode: Yup.string()
    .min(3, 'El código no puede tener menos de 3 caracteres')
    .max(8, 'El código no puede tener más de 8 caracteres')
    .test(
      'last-caracter',
      'El ultimo caracter del código debe ser una letra',
      (value) => {
        if (!value) {
          return true
        }
        const lastChar = value?.slice(-1)
        return /^[a-zA-Z]+$/.test(lastChar)
      }
    )
    .test(
      'start-code',
      'Los primeros caracteres antes del guión del código deben ser números',
      (value) => {
        if (!value) {
          return true
        }
        const valueArray = value.split('-')
        const lengthFirstChar = valueArray[0].length
        const firstChar = value.slice(0, lengthFirstChar)
        return /^[0-9]+$/.test(firstChar)
      }
    ),
  partnerZone: Yup.string(),
  partnerPrefecture: Yup.string(),
  partnerEndowment: Yup.string()
})

export const steepTwoSchema = Yup.object().shape({
  receptionDate: Yup.string(),
  name: Yup.string().required('El nombre es requerido'),
  isSpecialRegister: Yup.boolean(),
  babyDateBirth: Yup.string().when('isSpecialRegister', {
    is: false,
    then: Yup.string()
      .required('La Fecha de Nacimiento es Requerida')
      .test(
        'validate-max-90-days',
        'La solicitud no debe superar los 90 días desde el nacimiento del Hijo(a)',
        (value, context) => {
          const request = moment(context.parent.receptionDate)
          const current = moment(value)
          const diff = request.diff(current, 'days')
          return Boolean(!(diff > 90))
        }
      ),
    otherwise: Yup.string().required('La Fecha de Nacimiento es Requerida')
  }),
  birthCertificateName: Yup.array()
    .min(1, 'Se requieren al Menos 1 documentos')
    .required('El Certificado de Nacimiento es Requerido'),
  backupDocumentsName: Yup.array().when('isSpecialRegister', {
    is: true,
    then: Yup.array()
      .min(1, 'Se requieren al Menos 1 documento')
      .required('El documento es Requerido')
  }),
  observations: Yup.string()
})

export const steepThreeSchema = Yup.object().shape({
  lastSalaryPaymentName: Yup.array()
    .min(1, 'Se requieren al Menos 1 documentos')
    .required('La última liquidación es Requerida'),
  tipcarName: Yup.array()
    .min(1, 'Se requieren al Menos 1 documentos')
    .required('La copia de Tipcar es Requerida')
})
